import { Column } from '~components/table-view';

export const modalColumns: Column[] = [
  {
    id: 'service_date',
    header: 'Service Date',
    type: 'date',
  },
  {
    id: 'description',
    header: 'Service Name',
    type: 'text',
  },
  {
    id: 'unit_amount',
    header: 'Amount',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
];
